import { useQuery } from '@tanstack/react-query';
import type { IconName } from '@evogard/ui';
import { USEFUL_LINK_ICONS, loadFailureMessage } from '@evogard/domain';
import { api } from '../../lib/api.js';
import { useSessionContext } from '../../lib/session.js';

/**
 * Os ícones que um link útil pode ter, já como `IconName`.
 *
 * A anotação é a régua: `USEFUL_LINK_ICONS` mora no domínio, que não conhece o
 * pacote de interface, e esta linha só compila se todo valor de lá for um ícone
 * que `Icon` sabe desenhar.
 */
export const LINK_ICONS: readonly IconName[] = USEFUL_LINK_ICONS;

/** A lista da base atual — a tela de cartões e o cadastro leem a mesma. */
export function useUsefulLinks() {
  const { data: context } = useSessionContext();
  const tenantId = context?.currentTenant.id;
  return useQuery({
    // a base na chave: trocar de praça troca os links que estão na tela
    queryKey: ['plataforma', 'links-uteis', tenantId],
    queryFn: async () => {
      const r = await api.usefulLinks.listUsefulLinks();
      if (r.status !== 200) throw new Error(loadFailureMessage(r.status, 'os links'));
      return r.body;
    },
    enabled: tenantId !== undefined,
  });
}

/** Só o servidor do endereço, para o cartão dizer aonde o clique leva. */
export function hostOf(url: string): string {
  return url.replace(/^https?:\/\//i, '').replace(/[/?#].*$/, '');
}
